/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/hooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { parse, stringify } from 'hub-http/helpers/params';
import { useEffect } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { Metrics } from '../../Metrics';
import { usePlaylist } from '../savedItems/savedItemsQueries.migrated';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/hooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useIncorrectPlaylistRedirect = ({
  id,
  type,
  playlistId
}) => {
  const {
    playlist,
    playlistLoading,
    playlistError
  } = usePlaylist(playlistId, !playlistId);
  const history = useHistory();
  const navigate = useACNavigate();
  useEffect(() => {
    const playlistMissing = playlistError || playlistId && !playlistLoading && !playlist;
    const itemMissing = playlist && !playlist.items.find(item => item.type === type && item.itemId === id);
    if (playlistMissing || itemMissing) {
      const params = parse(history.location.search.slice(1));
      delete params.playlistId;
      const newSearch = stringify(params);
      navigate(Object.assign({}, history.location, {
        search: newSearch.length > 1 ? newSearch : ''
      }));
    }
    if (playlistMissing) {
      Metrics.counter('current-playlist-missing-redirect').increment();
    } else if (itemMissing) {
      switch (type) {
        case 'TRACK':
          Metrics.counter('current-track-not-in-playlist-redirect').increment();
          break;
        case 'LESSON':
          Metrics.counter('current-lesson-not-in-playlist-redirect').increment();
          break;
        case 'SHORT_FORM_CONTENT':
          Metrics.counter('current-short-not-in-playlist-redirect').increment();
          break;
        default:
          Metrics.counter('current-unkown-item-not-in-playlist-redirect').increment();
      }
    }
  }, [history, navigate, id, playlist, playlistError, playlistId, playlistLoading, type]);
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/hooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export { usePlaylistIdFromSearch } from 'academy-common-lib/features/playlistContent/hooks';